import { HTMLAttributes } from "react";

export default function Paypal(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9802 10.7988C19.6781 10.7991 19.3861 10.907 19.1565 11.1033C18.9269 11.2995 18.7748 11.5713 18.7276 11.8696L16.6464 25.0695C16.7434 24.453 17.2746 23.9988 17.8989 23.9988H23.9976C30.1354 23.9988 35.3437 19.5212 36.2953 13.4534C36.3661 13.0004 36.4063 12.5431 36.4154 12.0847C34.8556 11.2668 33.0233 10.7988 31.0155 10.7988H19.9802Z"
        fill="#001C64"
      />
      <path
        d="M36.4154 12.0852C36.4063 12.5436 36.3661 13.0009 36.2953 13.4539C35.3436 19.5217 30.1349 23.9993 23.9975 23.9993H17.8989C17.2751 23.9993 16.7434 24.453 16.6463 25.07L14.7327 37.1997L13.534 44.8092C13.5106 44.9562 13.5194 45.1065 13.5598 45.2498C13.6001 45.3931 13.6711 45.526 13.7677 45.6392C13.8644 45.7524 13.9845 45.8433 14.1197 45.9056C14.2549 45.9678 14.402 46.0001 14.5509 46H21.1705C21.4725 45.9997 21.7645 45.8918 21.9941 45.6955C22.2237 45.4993 22.3758 45.2276 22.423 44.9292L24.1666 33.8703C24.2139 33.5718 24.3661 33.3 24.5959 33.1037C24.8257 32.9074 25.118 32.7996 25.4202 32.7996H29.3175C35.4554 32.7996 40.6636 28.322 41.6153 22.2542C42.2911 17.9476 40.1221 14.0287 36.4154 12.0852Z"
        fill="#0070E0"
      />
      <path
        d="M12.4599 2C11.836 2 11.3043 2.45379 11.2073 3.06978L6.01278 36.0089C5.91428 36.6342 6.39749 37.1997 7.03063 37.1997H14.7337L16.6464 25.07L18.7276 11.8701C18.7748 11.5717 18.9269 11.3 19.1565 11.1038C19.3861 10.9075 19.6781 10.7996 19.9802 10.7993H31.0156C33.0238 10.7993 34.8556 11.2678 36.4154 12.0852C36.5223 6.56088 31.9638 2 25.6966 2H12.4599Z"
        fill="#003087"
      />
    </svg>
  )
}
